import { AddressEntityModel } from './AddressEntityModel';
import { ContactEntityModel } from './ContactEntityModel';

export class UserEntityModel {
    constructor(u) {
         
        this.username = u.username;
        this.first_name = u.firstName || u.username || '';
        this.last_name = u.lastName || '';
        this.email =u.email
        const addr = u.address || {};
        if (
            addr.city ||
            addr.country_id ||
            addr.postal_code ||
            addr.address_line1 ||
            addr.address_line2
        ) {
            this.address = new AddressEntityModel(addr);
        }
        if (u.contact && u.contact.phone) {
            this.contact = new ContactEntityModel(u.contact);
        }

        if(u.roles && u.roles.id)
        {
            this.roles=u.roles.id;

        }
        else
        {
            this.roles=u.roles
        }

        this.usertype = u.usertype != null ? Number(u.usertype) : 1;
        const assigned = Array.isArray(u.kot_access_types)
          ? u.kot_access_types.map(Number).filter((value) => [1, 2, 3].includes(value))
          : [];
        this.kot_access_types = assigned.length ? assigned : [this.usertype];
        this.usertype = this.kot_access_types[0];
        if (this.kot_access_types.includes(3) && u.waiter_id != null && u.waiter_id !== '') {
            this.waiter_id = Number(u.waiter_id);
        } else if (!this.kot_access_types.includes(3)) {
            this.waiter_id = null;
        }
    }


}
